module.exports = __webpack_public_path__ + "static/media/warning.2dba1d8f.svg";